import { fetchResources, set } from '../../_stores/_storeMethods'

export default {
  namespaced: true,
  state: {
    authorizeNetConfig: null,
    gateways: [
      {
        key: 'wire',
        label: 'Wire Transfer'
      },
      {
        key: 'check',
        label: 'Check'
      },
      {
        key: 'cc-an',
        label: 'Credit Card',
        labelInternal: 'Credit Card (Authorize.net)'
      },
      {
        key: 'cc-cs',
        label: 'Credit Card',
        labelInternal: 'Credit Card (Cybersource)'
      },
      {
        key: 'echeck-an',
        label: 'eCheck',
        labelInternal: 'eCheck (Authorize.net)'
      },
      {
        key: 'echeck-cs',
        label: 'eCheck',
        labelInternal: 'eCheck (CyberSource)'
      }
    ]
  },
  mutations: {
    set
  },
  actions: {
    fetchAuthorizeNetConfig(context) {
      return fetchResources(context, '/payment-terminal/config/an', 'authorizeNetConfig', {
        baseURL: '/'
      })
    }
  }
}
